import { render, staticRenderFns } from "./editablePlayersList.vue?vue&type=template&id=a4470cb4&scoped=true"
import script from "./editablePlayersList.vue?vue&type=script&lang=js"
export * from "./editablePlayersList.vue?vue&type=script&lang=js"
import style0 from "./editablePlayersList.vue?vue&type=style&index=0&id=a4470cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4470cb4",
  null
  
)

export default component.exports